module.exports = __webpack_public_path__ + "static/countdown.075a0d07.gif";